import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import isoWeek from "dayjs/plugin/isoWeek";

dayjs.extend(utc);
dayjs.extend(isoWeek);

const ISO_FORMAT = "YYYY-MM-DDTHH:mm:ss[Z]";

export const toIso = (value) => dayjs.utc(value).format(ISO_FORMAT);

export const isoWeekOf = (value) => dayjs.utc(value).isoWeek();

// Monday 00:00 UTC of the week containing `value`.
export const mondayOf = (value) => dayjs.utc(value).startOf("isoWeek");

// Whole weeks (in days) from the replay date to today, so the replay date lands
// in the current week, never in the future. Shifting by whole weeks keeps
// weekdays and calendar weeks lined up across harvest and climate data.
export const replayOffsetDays = (replayDate, today = new Date()) => {
  const days = dayjs.utc(today).startOf("day").diff(dayjs.utc(replayDate).startOf("day"), "day");
  return Math.floor(days / 7) * 7;
};

export const shiftDate = (value, days) => toIso(dayjs.utc(value).add(days, "day"));

// Move a calendar week number along with its date, keeping any offset the
// original data had between `calendar_week` and `date_time`.
const shiftWeek = (week, originalDate, shiftedDate) => {
  let shifted = isoWeekOf(shiftedDate) + (week - isoWeekOf(originalDate));
  if (shifted < 1) shifted += 52;
  if (shifted > 53) shifted -= 52;
  return shifted;
};

// For records without `date_time` (e.g. data visualization values).
export const shiftWeekNumber = (week, days) => (((week - 1 + days / 7) % 52) + 52) % 52 + 1;

// Shift one record that has `date_time` (and optionally calendar week fields).
export const shiftRecord = (record, days) => {
  if (!record || typeof record !== "object" || !record.date_time) return record;
  const shiftedDate = shiftDate(record.date_time, days);
  const shifted = { ...record, date_time: shiftedDate };
  ["calendar_week", "calendar_week_origin"].forEach((key) => {
    if (typeof record[key] === "number") {
      shifted[key] = shiftWeek(record[key], record.date_time, shiftedDate);
    }
  });
  if (Array.isArray(record.predictions)) {
    shifted.predictions = record.predictions.map((item) => shiftRecord(item, days));
  }
  return shifted;
};
